import type { ReducerState } from '../types';

export const INIT_STATE: ReducerState = {};
